"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonStringify = exports.parse = void 0;
var stringify_1 = require("./stringify");
var parse_1 = require("./parse");
function JSONBig(options) {
    return {
        parse: (0, parse_1.JSONParse)(options),
        stringify: stringify_1.stringify,
    };
}
exports.default = JSONBig;
exports.parse = (0, parse_1.JSONParse)();
exports.jsonStringify = stringify_1.stringify;
// create the default method members with no options applied for backwards compatibility
JSONBig.parse = exports.parse;
JSONBig.stringify = stringify_1.stringify;
